import { notify } from '../../shared';
import { Button } from '../../components';
import { getClipboardText, tryParseJSON } from '../../utilities';

type FromClipboardProps = {
  onChange?: (columns: DynamicColumnType[]) => void;
};

export const FromClipboard: React.FC<FromClipboardProps> = ({ onChange }) => {
  if (!onChange) return null;

  const handleFromClipboard = async () => {
    const text = await getClipboardText();
    const result = tryParseJSON(text);
    if (!Array.isArray(result)) {
      return notify.error("JSON wasn't of correct structure");
    }

    onChange?.(result);
  };

  return (
    <Button
      icon="copy"
      type="light"
      width="small"
      onClick={handleFromClipboard}
      tooltip="Populates columns from JSON in your clipboard"
    >
      From Clipboard JSON
    </Button>
  );
};
